module.exports = __webpack_public_path__ + "static/img/icon_nk.db1e313f.png";